import SpotkaniaElementy from "./SpotkaniaElementy"

export default SpotkaniaElementy
